import { styled } from "styled-components";

export const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
`;

export const PageTitleSubtitle = styled.h2`
  font-size: 16px;
  font-weight: bold;
`;

export const PageTitleDetail = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
`;
